/*
 * @Author: along longwang6@163.com
 * @Date: 2025-06-16 20:19:55
 * @LastEditors: along longwang6@163.com
 * @LastEditTime: 2025-06-24 21:29:19
 * @FilePath: /ehr-web/src/api/hunter.ts
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import Http from '@/http';
import {
  ISendSmsCodeParams,
  ISendSmsCodeResponse,
} from '@/api/typings/account';
import { PagedResponse } from './typings/common';
// import { IMember } from './typings/common';

interface ILoginParams {
  code?: string;
  mobile?: string;
  orgId?: string;
}

export function apiHunterLogin(params: ILoginParams) {
  return Http.post<ILoginParams, { token: string }>(
    '/hr/recruit/hunter/login',
    params
  );
}

export function apiHunterLogout() {
  return Http.get<void, void>('/hr/recruit/hunter/logout');
}

export function apiHunterUserInfo() {
  return Http.get<void, any>('/hr/recruit/hunter/my_info');
}

export function apiHunterSendSmsCode(params: ISendSmsCodeParams) {
  return Http.post<ISendSmsCodeParams, ISendSmsCodeResponse>(
    '/hr/recruit/hunter/send_sms_code',
    params
  );
}

// 导入候选人
export function apiHunterImportCandidate(params: {
  positionId: number;
  list: any[];
}) {
  return Http.post<any, PagedResponse<any>>(
    '/hr/recruit/hunter/candidate/import',
    params
  );
}

// 手机号过滤
export function apiHunterPhoneFilter(params: {
  mobile: string[];
  positionId: number;
}) {
  return Http.get<any, PagedResponse<any>>(
    '/hr/recruit/hunter/candidate/phone_fliter',
    params
  );
}

// 我的猎头信息
export function apiGetMyRecommendList() {
  return Http.get<any, PagedResponse<any>>('/hr/recruit/hunter/my_info', {});
}

// 我的可推荐岗位列表
export function apiGetHunterPositionList(params: {
  key?: string;
  id?: number;
}) {
  return Http.get<any, PagedResponse<any>>(
    '/hr/recruit/hunter/position/list',
    params
  );
}

// 我的内推列表
export function apiGetMyInternalRecommendList() {
  return Http.post<any, PagedResponse<any>>(
    '/hr/recruit/hunter/referrer/list',
    {}
  );
}
